import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Articles() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Explore articles about luxury hotels and accommodations on First-Class.com. Find inspiration for your next upscale stay'
          }
        />
        <title>Hotel Articles: In-Depth Hotel Insights</title>
      </Head>
      <ArticlesList subtype="Articles" type="Hotels" />
    </>
  );
}

export default withLayout(Articles, true);
